import { useTranslation } from 'react-i18next'

import { returnStatuses } from '@reveni-io/reveni-ui'

import { isExchangeOrMixedWithoutPayment, isExchangeOrMixedWithPayment } from '../helpers'
import { getTextForWhenIssueExchange } from './helpers'

const ExchangeMessage = ({
  exchangedForOrder,
  orderTransactionType,
  orderStatus,
  isInstant,
  issueExchangeAtStatus,
  storeName,
}) => {
  const { t, i18n } = useTranslation()

  const issueExchangeText = getTextForWhenIssueExchange(t, issueExchangeAtStatus, storeName)

  if (orderStatus === returnStatuses.cancelled) {
    return (
      <p>
        <strong>
          {t('Ha habido un problema y no ha sido posible procesar el envío de los nuevos productos que solicitaste.')}
        </strong>
      </p>
    )
  }

  return (
    <>
      {isExchangeOrMixedWithPayment(orderTransactionType, exchangedForOrder) && (
        <p>
          <strong>
            {t('Completa ahora el pago de los {{amount}} pendientes para iniciar el proceso de cambio.', {
              amount: new Intl.NumberFormat(i18n.language, {
                style: 'currency',
                currency: exchangedForOrder?.currency || 'EUR',
              }).format(exchangedForOrder?.amount || 0),
            })}
          </strong>
        </p>
      )}

      {isExchangeOrMixedWithoutPayment(orderTransactionType, exchangedForOrder) && (
        <p>
          {!isInstant &&
          [returnStatuses.accepted, returnStatuses.received, returnStatuses.shipped].includes(issueExchangeAtStatus) ? (
            t('Te enviaremos un enlace para que puedas completar el pago {{issueExchangeText}}.', {
              issueExchangeText,
            })
          ) : (
            <strong>
              {t(
                'Te enviaremos un enlace para que puedas completar el pago de los {{amount}} pendientes y así iniciar el proceso de cambio.',
                {
                  amount: new Intl.NumberFormat(i18n.language, {
                    style: 'currency',
                    currency: exchangedForOrder?.currency || 'EUR',
                  }).format(exchangedForOrder?.amount || 0),
                }
              )}
            </strong>
          )}
        </p>
      )}
    </>
  )
}

export default ExchangeMessage
